module.exports = __webpack_public_path__ + "static/media/bagy9.97b48a11.png";